import { Anchor, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const ZillowNavbarLinkAnchorHoverStylingMixin = css`
    color: ${token('colors.brand')} !important; // pfs styles compete with ours
`;

type ZillowNavbarLinkAnchorProps = {
    isActive?: boolean;
};

export const ZillowNavbarLinkAnchor = styled(Anchor)<ZillowNavbarLinkAnchorProps>`
    ${({ isActive }) => css`
        font-family: ${token('fonts.sansSerif')};
        color: ${token('colors.textDark')};
        text-decoration: none;
        padding: 12px 14px;
        text-align: center;
        &:hover {
            ${ZillowNavbarLinkAnchorHoverStylingMixin};
        }
        &:visited {
            color: ${token('colors.textDark')} !important; // pfs styles compete with ours
        }
        &:visited:hover {
            ${ZillowNavbarLinkAnchorHoverStylingMixin};
        }
        ${isActive && ZillowNavbarLinkAnchorHoverStylingMixin}
    `}
`;
